/*
	CSS
*/
require('../css/load-main.css');
require('../css/load-builder.css');

/*
	scripts (as conventional globals)
*/
require("script!./vendor/jquery.min.js");
require("script!./vendor/jquery-ui.min.js");
require("script!./vendor/flat-ui-pro.min.js");
require("script!./vendor/chosen.min.js");
require("script!./vendor/jquery.zoomer.js");
require("script!./vendor/spectrum.js");
require("script!./vendor/summernote.min.js");
require("script!./vendor/jquery.dnd_page_scroll.js");

/*
	application modules
*/
require('./modules/ui.js');
require('./modules/builder.js');
require('./modules/config.js');
require('./modules/utils.js');
require('./modules/canvasElement.js');
require('./modules/styleeditor.js');
require('./modules/imageLibrary.js');
require('./modules/content.js');
require('./modules/sitesettings.js');
require('./modules/export.js');
require('./modules/preview.js');
require('./modules/revisions.js');
require('./modules/templates.js');
require('./modules/components.js');
require('./modules/grid.js');
require('./modules/polyfills.js');

$(document).ready(function() {
	"use strict";
	$().dndPageScroll();
});


//////////////////
// WEBPACK FOOTER
// ./assets/js/builder.js
// module id = 0
// module chunks = 1